module.exports = __webpack_public_path__ + "static/media/3_apollo.a36f4339.svg";